// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__187Oy","colMin":"styles_colMin__3roru"};